import customSelect from 'jquery-custom-select';

var $select = $( '.c-select' );

$select.customSelect({
	includeValue: true,
});
